import { useState, useContext, useEffect } from "react"
import { GlobalContextProvider } from "../components/functions/GlobalContext"
import {
    Box,
    Text,
    VStack,
    Stack,
    Center,
    FormControl,
    Input,
    Button,
    Select,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Spacer,
    Grid, GridItem, Tooltip,
} from "@chakra-ui/react"
import InfoModal from "../components/modals/InfoModal"
import ConfirmModal from "./modals/ConfirmModal"
import { BsFillTrashFill } from 'react-icons/bs';
import { fixStringLength } from "./functions/Common"
import { useTranslation } from 'react-i18next';
import { sanitize, sanitizeNumber } from "./functions/Common";
import { Twirp, TwirpProps } from "../components/functions/Twirp"
import Const from "../Consts";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

type RouteParams = {
    userid: string
}


export type CoachExpType = {
    key: number,
    year: string,
    position: number,
    team: string,
}

type ListType = {
    value: number,
    label: string,
}

type RegisterCoachExpProps = {
    selectedFunction: (prestasi: CoachExpType[]) => void
}

export default function RegisterCoachExpPage(props: RegisterCoachExpProps) {
    const { t, i18n } = useTranslation();
    const globalContext = useContext(GlobalContextProvider)
    const params = useParams<RouteParams>();
    const navigate = useNavigate()

    const [usecase, setUsecase] = useState(0) //three ways: 0) as register form   1) as edit   2) as view from other user

    const [curentKeyNumber, setCurrentKeyNumber] = useState<number>(0)

    const [formData, setFormData] = useState<CoachExpType>({
        key: 0,
        year: "2000",
        position: 0,
        team: "",
    })
    const [prestasiList, setPrestasiList] = useState<CoachExpType[]>([])

    const posisiPengalaman = [{ value: 0, label: t("member") }, { value: 1, label: t("Coach") }, { value: 2, label: t("Supervisor") },
    ]

    const [modalData, setModalData] = useState({
        title: "",
        main: "",
        isOpen: false,
    })
    const closeModal = () => {
        setModalData({ ...modalData, isOpen: false })
    }

    const [cmData, setCmData] = useState({
        title: "",
        main: "",
        isOpen: false,
        closeText: "",
        confirmText: "",
        actionKey : 0,
    })
    const confirmModalOpens = (key: number) => {
        setCmData({ ...cmData, isOpen: true, actionKey: key, title:t('confirm_requested'), main: t('remove_this_line'),
            closeText: t('Cancel'), confirmText: t('Delete')})              
    }
    const confirmModalIsClosed = () => {
        setCmData({ ...cmData, isOpen: false })
    }
    const confirmModalOkFunction = () => {
        removeFromList(cmData.actionKey)
        setCmData({ ...cmData, isOpen: false })
    }



    const addToPrestasiList = () => {
        if (formData.team.length < 3) {
            return
        }
        setCurrentKeyNumber(curentKeyNumber + 1) //always increase primary key to make it unique per row
        const newData = { key: curentKeyNumber, year: formData.year, team: formData.team, position: formData.position }
        setPrestasiList([...prestasiList, newData])
        setFormData({
            ...formData,
            year: "2000",
            position: 0,
            team: "",
        })
        props.selectedFunction([...prestasiList, newData])
    }

    const removeFromList = (key: number) => {
        const newData = prestasiList.filter((p) => p.key !== key);
        setPrestasiList(newData)
        props.selectedFunction([...newData])
    }

    const loadData = async (idToSearch: number) => {

        const tprops: TwirpProps = {
            url: Const.API_ReadPrestasi, headers: { Authorization: globalContext?.GetLoginData().token }, timeout: 5000,
            data: { pesilat_id: idToSearch, type: 2 }
        }
        const result = await Twirp(tprops)
        if (result.state == 2) {//other error
            setModalData({ ...modalData, isOpen: true, title: result.axiosError.code, main: result.axiosError.message })
        } else if (result.state == 1) {//twirp controlled error
            // let msg = result.axiosError.response?.data?.msg || result.axiosError.message
            // setModalData({ ...modalData, isOpen: true, title: result.axiosError.code, main: msg })

            if (result.axiosError.response?.status == 401) {
                navigate('/logout')
            }
        } else { //successful
            if (result.data.prestasiList?.length > 0) {

                let currentKey = curentKeyNumber //always increase primary key to make it unique per row
                let tempPrestasi: CoachExpType[] = []
                result.data.prestasiList.forEach((value: any, index: any) => {
                    const newData = {
                        key: currentKey,
                        year: "" + value.year,
                        position: value.position,
                        team: value.team,
                    }
                    currentKey++
                    tempPrestasi = [...tempPrestasi, newData]
                });
                setCurrentKeyNumber(currentKey)
                setPrestasiList(tempPrestasi)
                props.selectedFunction(tempPrestasi)
            }
        }
    }


    useEffect(() => {

        if (globalContext?.GetLoginData().username !== "") {

            const userId = globalContext?.GetLoginData().userId || 0
            const pesilatID = +(params.userid || userId)
            if (pesilatID > 0) {
                if (globalContext?.GetLoginData().isAdmin) {
                    setUsecase(1) //admin is allowed to edit
                } else if (pesilatID == globalContext?.GetLoginData().userId) {
                    setUsecase(1) //editing own profile
                } else {
                    setUsecase(2) //viewing other user profile
                }
            }
            loadData(pesilatID)

        } else {
            setUsecase(0)
        }
    }, [])



    return (

        <Center py={"10px"} px={"10px"} maxW='m' borderWidth='2px' borderRadius='lg' overflow='hidden' >
            <InfoModal isOpen={modalData.isOpen} title={modalData.title} mainText={modalData.main} closeFunction={closeModal} />
            <ConfirmModal isOpen={cmData.isOpen} closeFunction={confirmModalIsClosed} closeButtonText={cmData.closeText} confirmButtonText={cmData.confirmText}
                confirmFunction={confirmModalOkFunction}  title={cmData.title} mainText={cmData.main}/>

            <FormControl alignItems={'center'}>

                <VStack>

                    {usecase < 2 ? (
                        <VStack maxW={['xs','sm']}>
                            <Center><Text fontSize={'sm'}>{t('add_coach_exp')}</Text></Center>
                            <Grid py='2px' templateColumns='repeat(2, 1fr)' gap={0} alignItems='center'>
                                <Text fontSize={'sm'}>{t('Year')}</Text>
                                <Input type='text' size='sm' value={formData.year} onChange={(e) => setFormData({ ...formData, year: sanitizeNumber(e.target.value) })} maxLength={4} />
                            </Grid>                            
                            <Grid py='2px' templateColumns='repeat(2, 1fr)' gap={0} alignItems='center'>
                                <Text fontSize={'sm'}>{t('TimCabangRanting')}</Text>
                                <Input size='sm' type='text'  value={formData.team} onChange={(e) => setFormData({ ...formData, team: sanitize(e.target.value) })} maxLength={64} />
                            </Grid>
                            <Center>
                                <Button size='sm' isDisabled={formData.year.length < 4 || formData.team.length < 1 } 
                                    colorScheme='blue' onClick={addToPrestasiList}>{t('Add to List')}</Button>
                            </Center>
                        </VStack>
                    ) : ''}


                    <TableContainer w='400px'>
                        <Table variant='simple' colorScheme='blue' size='sm'>
                            <Thead>
                                <Tr>
                                    <Th>{t('Year')}</Th>
                                    <Th>{t('Event Name')}</Th>
                                    {usecase < 2 ? (<Th></Th>) : ''}
                                </Tr>
                            </Thead>
                            <Tbody>
                                {prestasiList.map(({ key, year, position, team }) => (
                                    <Tr key={key}>
                                        <Td>{year}</Td>
                                        <Td><Tooltip label={team}>{fixStringLength(team, 22)}</Tooltip></Td>
                                        {usecase < 2 ? (
                                            <Td fontSize={'xs'}>
                                                <Button size='xs' colorScheme='pink' onClick={() => confirmModalOpens(key)}><BsFillTrashFill/></Button>
                                            </Td>
                                        ) : ''}
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>



                    <Spacer minH='25px' />
                </VStack>
            </FormControl>

        </Center>

    )

}
